/**
 *
 */
window.APP.Arrows = class {
  #disabledClass = 'slick-disabled';

  constructor(mediaCnt, prevArrow, nextArrow) {
    this.mediaLast = mediaCnt - 1;
    this.prev = prevArrow;
    this.next = nextArrow;
  }

  update(index) {
    switch (Number(index)) {
      case 0:
        this.prev.classList.add(this.#disabledClass);
        this.next.classList.remove(this.#disabledClass);
        break;
      case this.mediaLast:
        this.prev.classList.remove(this.#disabledClass);
        this.next.classList.add(this.#disabledClass);
        break;
      default:
        this.prev.classList.remove(this.#disabledClass);
        this.next.classList.remove(this.#disabledClass);
    }
  }
}
